import React from 'react';
// Trigger rebuild
import {
  LayoutDashboard,
  Landmark,
  AlertTriangle,
  ShieldCheck,
  Activity,
  Siren,
  ClipboardCheck,
  BadgeCheck,
  Wrench,
  CalendarClock,
  Settings,
  Building2,
  Users,
  GanttChart,
  Gauge
} from 'lucide-react';

export interface ModuleMeta {
  id: string;              // unique slug
  label: string;           // display name
  icon: React.ReactNode;   // Lucide icon component
  order: number;           // ordering in lifecycle sequence
  path: string;            // canonical route path
  lifecycleGroup?: string; // foundation | governance | risk | control | detect | respond | assurance | support
  enabled?: boolean;       // feature flag (future)
  showInSidebar?: boolean; // if false, hidden from left nav
  showInRadial?: boolean;  // if false, omitted from radial map
}

// Single source of truth for module ordering & labels powering Sidebar & RadialNavigator
// To add a new module: append here with proper order, then implement rendering case in MainContent.
export const MODULES: ModuleMeta[] = [
  { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} />, order: 0, path: '/dashboard', lifecycleGroup: 'foundation', showInSidebar: false, showInRadial: false },
  { id: 'organisation', label: 'Organisation', icon: <Building2 size={20} />, order: 1, path: '/organisation', lifecycleGroup: 'foundation', showInSidebar: true, showInRadial: true },
  { id: 'users', label: 'User Management', icon: <Users size={20} />, order: 2, path: '/users', lifecycleGroup: 'foundation', showInSidebar: false, showInRadial: false },
  { id: 'governance', label: 'Governance', icon: <Landmark size={20} />, order: 3, path: '/governance', lifecycleGroup: 'governance', showInSidebar: true, showInRadial: true },
  { id: 'risk', label: 'Risk', icon: <AlertTriangle size={20} />, order: 4, path: '/risk', lifecycleGroup: 'risk', showInSidebar: true, showInRadial: true },
  { id: 'internal-controls', label: 'Internal Controls', icon: <ShieldCheck size={20} />, order: 5, path: '/internal-controls', lifecycleGroup: 'control', showInSidebar: true, showInRadial: true },
  { id: 'compliances', label: 'Compliances', icon: <ClipboardCheck size={20} />, order: 6, path: '/compliances', lifecycleGroup: 'governance', showInSidebar: true, showInRadial: true },
  { id: 'audits', label: 'Audits', icon: <BadgeCheck size={20} />, order: 7, path: '/audits', lifecycleGroup: 'assurance', showInSidebar: true, showInRadial: true },
  { id: 'monitoring', label: 'Continuous Monitoring', icon: <Activity size={20} />, order: 8, path: '/monitoring', lifecycleGroup: 'detect', showInSidebar: true, showInRadial: true },
  { id: 'incidence-reporting', label: 'Incident Reporting', icon: <Siren size={20} />, order: 9, path: '/incidence-reporting', lifecycleGroup: 'respond', showInSidebar: true, showInRadial: true },
  { id: 'capa', label: 'CAPA Action', icon: <Wrench size={20} />, order: 10, path: '/capa', lifecycleGroup: 'respond', showInSidebar: true, showInRadial: true },
  { id: 'cadence', label: 'Cadence', icon: <CalendarClock size={20} />, order: 11, path: '/cadence', lifecycleGroup: 'support', showInSidebar: true, showInRadial: true },
  { id: 'project-management', label: 'Project Management', icon: <GanttChart size={20} />, order: 12, path: '/project-management', lifecycleGroup: 'support', showInSidebar: true, showInRadial: true },
  { id: 'performance-measures', label: 'Performance Measures', icon: <Gauge size={20} />, order: 13, path: '/performance-measures', lifecycleGroup: 'assurance', showInSidebar: true, showInRadial: true },
  { id: 'settings', label: 'Settings', icon: <Settings size={20} />, order: 14, path: '/settings', lifecycleGroup: 'support', showInSidebar: true, showInRadial: false }
];
